<script setup lang="ts">
import type { PropertyColor, PropertySize } from "~/classes/generated/interface"

import { mediaType, mimeTypeString, Property, PropertySchema } from "~/classes/entity"

const props = defineProps({
  file: null,
  propertyId: null,
  size: null,
  color: null,
  selected: { type: Boolean },
  diff: null,
  multiline: { type: Boolean },
  maxLines: null
})
const { viewModePropertySizes, viewModePropertyColors } = useViewMode()
const property = computed(() => props.file.property(props.propertyId))
</script>

<template>
  <div
    class="text"
    :data-property-id="propertyId"
    :style="multiline && maxLines ? multilineTextCss(maxLines) : {}"
    :class="{
      [viewModePropertySizes[size].textCss]: true,
      [viewModePropertyColors[color].textCss]: !selected,
    }"
  >
    <template v-if="property && property.value.type === PropertySchema.NonEmptyStringValue">
      {{ property.value.nonEmptyString }}
    </template>
    <template v-else-if="property && property.value.type === PropertySchema.AnyStringValue">
      {{ property.value.anyString }}
    </template>
    <template v-else-if="property && property.value.type === PropertySchema.MimeTypeValue">
      {{ mimeTypeString(property.value.mimeType) }}
    </template>
    <template v-else-if="propertyId === Property.FILE_VIRTUAL_MEDIA_TYPE && file.mimeType()">
      <span class="media-type">{{ mediaType(file.mimeType()!) }}</span>
    </template>
    <template v-else-if="property && property.value.type === PropertySchema.SizeBytesValue">
      {{ formatBytes(property.value.sizeBytes) }}
    </template>
    <template v-else-if="property && property.value.type === PropertySchema.NonNegativeIntegerValue && property.propertyId === Property.MEDIA_DURATION_MS">
      {{ msToHhMmSs(property.value.nonNegativeInteger) }}
    </template>
    <template v-else-if="property && property.value.type === PropertySchema.PositiveIntegerValue">
      {{ prettyNumber(property.value.positiveInteger) }}
    </template>
    <template v-else-if="property && property.value.type === PropertySchema.NonNegativeIntegerValue">
      {{ prettyNumber(property.value.nonNegativeInteger) }}
    </template>
    <template v-else-if="property && property.value.type === PropertySchema.PositiveFloatValue">
      {{ prettyNumber(property.value.positiveFloat) }}
    </template>
    <template v-else-if="property">
      ???
    </template>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.text
  @apply text-ellipses-inline rounded-[#{$page-properties-br-overlay}]
  @apply rounded-[#{$page-properties-br-overlay}] px-1.5 py-0.5
  // For some reason overflow wrap doesn't work here?
  word-break: break-word

.diff
  @apply inline
  .deleted
    @apply bg-$global-red-secondary
  .added
    @apply hidden

.media-type
  @apply capitalize
</style>
